// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3ADYn","footer":"ModalError_footer__375LV"};